module.exports = __webpack_public_path__ + "img/img5.7b68a392.png";